// src/config.js
const config = {
  API_URL: "https://joharischool.emagetechnologiesltd.com/shule/public",
  APP_URL: "https://joharischool.emagetechnologiesltd.com",
};

export default config;
